var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myPostIndex"},[_c('img',{staticClass:"avater1",attrs:{"src":_vm.userStatus.companyLogo}}),_c('p',{staticClass:"nickname"},[_vm._v("\n        "+_vm._s(_vm.userStatus.company)+"\n    ")]),_c('el-button',{staticClass:"bdButton",attrs:{"type":"danger"},on:{"click":_vm.quit}},[_vm._v("退出登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }